module.exports = {
  dish1: {
    name: "Pizza 1",
    description: "Insert Pizza 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Pizza 2",
    description: "Insert Pizza 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Pizza 3",
    description: "Insert Pizza 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Pizza 4",
    description: "Insert Pizza 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Pizza 5",
    description: "Insert Pizza 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Pizza 6",
    description: "Insert Pizza 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Pizza 7",
    description: "Insert Pizza 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Pizza 8",
    price: 4400,
    description: "Insert Pizza 8 description",
    status: "available"
  },
  dish9: {
    name: "Pizza 9",
    price: 3300,
    description: "Insert Pizza 9 description",
    status: "available"
  },
  dish10: {
    name: "Pizza 10",
    price: 3900,
    description: "Insert Pizza 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/Bingo.js